<template>
	<div class="px-4 mt-2 file-input-field">
		<v-file-input
			outlined
			show-size
			v-if="!widgetLogo"
			:loading="loading"
			accept="image/png"
			class="file-input"
			truncate-length="30"
			@change="filePicked"
			label="Upload file"
			color="deep-purple accent-4"
			prepend-icon="mdi-paperclip"
			placeholder="Select your logo"
		>
			<template v-slot:progress>
				<br />
				<v-progress-linear v-model="uploadProgress" height="25">
					<strong>{{ Math.ceil(uploadProgress) }}%</strong>
				</v-progress-linear>
			</template>
		</v-file-input>
		<div v-else class="display-flex lfex-row flex-justify-space-between flex-align-center">
			<a :href="widgetLogo" target="_blank">Uploaded icon</a>
			<AnemicButton class="delete-button" @click="updateWorkflowVersionSettings(null)">Remove File</AnemicButton>
		</div>
	</div>
</template>

<script>
import api from '@/api';
import { mapGetters, mapActions } from 'vuex';
import { updateWorkflowSetting } from '@/store/modules/selectedWorkflow/actions.js';
import { getWorkflowAppearanceSettings } from '@/store/modules/selectedWorkflow/getters.js';

export default {
	name: 'WidgetLogoUpload',
	computed: {
		...mapGetters([getWorkflowAppearanceSettings.fullPath]),
		workflowAppearanceSettings() {
			return this[getWorkflowAppearanceSettings.fullPath];
		},
		widgetLogo() {
			return this.workflowAppearanceSettings.logo;
		},
	},
	methods: {
		...mapActions([updateWorkflowSetting.fullPath]),
		updateWorkflowVersionSettings(value) {
			if (!value) {
				this[updateWorkflowSetting.fullPath]({ key: 'logo', value });
			}
		},
		async filePicked(file) {
			this._uploadFile(file);
		},
		async _uploadFile(file) {
			if (!file) {
				this.updateWorkflowVersionSettings(null);
				return;
			}
			this.loading = true;
			try {
				const uploadedFile = await this.uploadFile(file);
				this.updateWorkflowVersionSettings(uploadedFile, file.name);
				console.log(`Uploaded file success:`, uploadedFile);
			} catch (err) {
				console.log('err = ', err);
				alert('Error while uploading file');
			} finally {
				this.loading = false;
			}
		},
		async uploadFile(file) {
			const r = await api.updateWorkflowSettingImage(this.workflowAppearanceSettings.id, file, 'logo');
			return r.logo;
		},
	},
	data() {
		return {
			loading: false,
			uploadProgress: 0,
			outlinedInput: false, //Customization for WidgetFieldMixin default behavior
		};
	},
};
</script>
<style scoped lang="scss">
.delete-button {
	width: 89px;
	height: 25px !important;
	color: var(--button-text);
	font-size: 12px !important;
	border: 1px solid var(--button-text);
	background: var(--bg-color) !important;
}

.file-input {
	::v-deep {
		.v-label {
			top: 8px !important;
		}
		.v-input__prepend-outer {
			margin-top: 6px !important;
		}
	}
}
</style>
